<template>
  <v-form ref="form" @submit.prevent="saveVehicle">
    <v-text-field
      v-if="visibleFields.includes('make')"
      v-model="vehicle.make"
      label="Marca"
      outlined
      dense
      required
    ></v-text-field>
    <v-text-field
      v-if="visibleFields.includes('body_type')"
      v-model="vehicle.body_type"
      label="Tipo"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('model')"
      v-model="vehicle.model"
      label="Modelo"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('year')"
      v-model="vehicle.year"
      label="Año"
      outlined
      dense
      required
      type="number"
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('color')"
      v-model="vehicle.color"
      label="Color"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('chassis_make')"
      v-model="vehicle.chassis_make"
      label="Chasis Marca"
      outlined
      dense
      required
    ></v-text-field>
    <v-text-field
      v-if="visibleFields.includes('chassis_number')"
      v-model="vehicle.chassis_number"
      label="Chasis N° "
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('motor_make')"
      v-model="vehicle.motor_make"
      label="Marca Motor"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('motor_number')"
      v-model="vehicle.motor_number"
      label="Motor N°"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-if="visibleFields.includes('certificate_number')"
      v-model="vehicle.certificate_number"
      label="Certificado  N°"
      outlined
      dense
      required
    ></v-text-field>

    <!--v-text-field
      v-if="visibleFields.includes('version')"
      v-model="vehicle.version"
      label="Serie"
      outlined
      dense
      required
    ></v-text-field-->

    <v-text-field
      v-if="visibleFields.includes('plate')"
      v-model="vehicle.plate"
      label="Patente"
      outlined
      dense
      required
    ></v-text-field>

    <!--v-text-field
      v-if="visibleFields.includes('price')"
      v-model="vehicle.price"
      label="Precio"
      outlined
      dense
      required
    ></v-text-field-->

    <!--v-text-field
      v-if="visibleFields.includes('position')"
      v-model="vehicle.position"
      label="Posición"
      outlined
      dense
      required
    ></v-text-field-->

    <!--v-text-field
      v-if="visibleFields.includes('factory_id')"
      v-model="vehicle.factory_id"
      label="ID Fábrica"
      outlined
      dense
      required
    ></v-text-field-->

    <!--v-text-field
      v-if="visibleFields.includes('vin')"
      v-model="vehicle.vin"
      label="VIN"
      outlined
      dense
      required
    ></v-text-field-->

    <v-select
      v-if="visibleFields.includes('status')"
      v-model="vehicle.status"
      label="Estado"
      :items="statusOptions"
      outlined
      dense
    ></v-select>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancelar</v-btn>
      <v-btn color="primary" type="submit">{{
        isEditing ? "Actualizar" : "Guardar"
      }}</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
export default {
  name: "VehicleForm",
  props: {
    mode: { type: String, required: true }, // 'create' o 'edit'
    vehicleData: { type: Object, default: () => ({}) }, // Datos en edición
    source: { type: String, required: true }, // Fuente de creación ('salon', 'venta', 'servicio', 'otro')
    visibleFields: {
      // Lista de campos a mostrar
      type: Array,
      default: () => [
        "make",
        "body_type",
        "model",
        "year",
        //"version",
        "plate",
        //"price",
        "chassis_number",
        "chassis_make",
        "motor_make",
        "motor_number",
        "certificate_number",
        //"color",
        //"position",
        //"factory_id",
        //"vin",
        "status",
      ],
      //required: true,
    },
  },
  data() {
    return {
      vehicle: {
        make: "ALFA ROMEO",
        body_type: "",
        model: "",
        year: "",
        //version: "",
        plate: "",
        //price: 0,
        chassis_make: "ALFA ROMEO",
        chassis_number: "",
        color: "",
        //position: "",
        //factory_id: "",
        motor_number: "",
        motor_make: "ALFA ROMEO",
        //vin: "",
        certificate_number: "",
        status: this.getDefaultStatus(),
      },
    };
  },
  /*watch: {
    vehicleData: {
      handler(newData) {
        this.vehicle = { ...newData };
      },
      deep: true,
      immediate: true,
    },
  },*/
  computed: {
    isEditing() {
      return this.mode === "edit";
    },
    statusOptions() {
      switch (this.source) {
        case "salon":
          return ["salon"];
        case "venta":
          return ["vendido"];
        case "servicio":
          return ["vendido", "otros"];
        default:
          return ["otros"];
      }
    },
  },
  methods: {
    saveVehicle() {
      this.$emit("save", { ...this.vehicle });
    },
    getDefaultStatus() {
      switch (this.source) {
        case "salon":
          return "salon";
        case "venta":
          return "vendido";
        case "servicio":
          return "otros";
        default:
          return "otros";
      }
    },
    setVehicleData(data) {
      this.vehicle = { ...this.vehicle, ...data };
    },
    clear() {
      this.vehicle = {
        make: "ALFA ROMEO",
        body_type: "",
        model: "",
        year: "",
        //version: "",
        plate: "",
        color: "",
        //price: 0,
        chassis_number: "",
        chassis_make: "ALFA ROMEO",
        //position: "",
        //factory_id: "",
        motor_number: "",
        motor_make: "ALFA ROMEO",
        //vin: "",
        certificate_number: "",
        status: this.getDefaultStatus(),
      }
    }
  },
};
</script>
